var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEuroicon = function SvgEuroicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#637384",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#637384",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M10.547 9.906a1.907 1.907 0 0 1-1.88 1.914H8a1.905 1.905 0 0 1-1.906-1.914V6.093A1.907 1.907 0 0 1 8 4.18h.667a1.907 1.907 0 0 1 1.913 1.913M4.82 6.727h2.547M4.82 9.273h2.547"
  })));
};
export default SvgEuroicon;